module.exports = __webpack_public_path__ + "media/images/facebook-c6a516e605cba6f2aa4c8cabf848c093.gif";